<template>
    <span class="stars" @mouseleave="mouseOut">
        <span :class="className(1)" :data-id="1" @mouseover="mouseOver" @click="add"><span class="glyphicon glyphicon-star" aria-hidden="true"></span></span>
        <span :class="className(2)" :data-id="2" @mouseover="mouseOver" @click="add"><span class="glyphicon glyphicon-star" aria-hidden="true"></span></span>
        <span :class="className(3)" :data-id="3" @mouseover="mouseOver" @click="add"><span class="glyphicon glyphicon-star" aria-hidden="true"></span></span>
        <span :class="className(4)" :data-id="4" @mouseover="mouseOver" @click="add"><span class="glyphicon glyphicon-star" aria-hidden="true"></span></span>
        <span :class="className(5)" :data-id="5" @mouseover="mouseOver" @click="add"><span class="glyphicon glyphicon-star" aria-hidden="true"></span></span>
    </span>
</template>
<script>
export default {
    props: {
        pid: {
            type: [String, Number],
            required: true,
            default: null
        }
    },

    data() {
        return {
            mouseOverId: 0,
            rating: 0
        }
    },

    created() {
        new Form({
            pid: this.pid
        })
        .post('/api/productratings/current-rating')
        .then((response) => {
            if(response.success) {
                this.rating = Math.round(response.rating);
            }
        })
    },

     methods: {
        mouseOver({currentTarget}) {
            this.mouseOverId = currentTarget.dataset.id;
        },

        mouseOut() {
            this.mouseOverId = 0;
        },

        className(id) {
            if (this.isMouseOver(id)) {
                return "blue";
            } else {
                return this.isInRating(id) ? "black" : "white";
            }
        },

        isMouseOver(id) {
            return this.mouseOverId >= id;
        },

        isInRating(id) {
            return this.rating >= id;
        },

        add({currentTarget}) {
            new Form({
                pid: this.pid,
                rating: currentTarget.dataset.id
            })
            .post('/api/productratings/add')
            .then((response) => {
                if(response.success) {
                    this.rating = Math.round(response.rating);
                    App.event.fire('product.rating.update', response.rating);
                    App.event.fire('product.rating.update.num', response.numVotes);
                } else {
                    swal("", "Um das Produkt bewerten zu können, müssen Sie angemeldet sein.",  "error");
                }
            })
        }
    }
}
</script>
